function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var MenuIcon = function MenuIcon(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "9",
    viewBox: "0 0 20 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "1.92857",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "9.41177",
    y: "7.07129",
    width: "10.5882",
    height: "1.92857",
    fill: "#222222"
  }));
};

export default MenuIcon;